interface FormattingButtonProps {
  readonly label: 'Bold' | 'Italic';
  readonly pressed: boolean;
  readonly disabled?: boolean;
  readonly onClick: () => void;
}

/** Shared authored-text formatting treatment; weight selectors remain independent. */
export function FormattingButton({
  label,
  pressed,
  disabled = false,
  onClick,
}: FormattingButtonProps) {
  return (
    <button
      aria-label={label}
      aria-pressed={pressed}
      className={`formatting-button formatting-button-${label.toLowerCase()}`}
      disabled={disabled}
      onClick={onClick}
      title={disabled ? `${label} is unavailable for this font` : label}
      type="button"
    >
      {label === 'Bold' ? 'B' : 'I'}
    </button>
  );
}
